module.exports = __webpack_public_path__ + "static/media/benefits4.4ed35ad7.png";